revertPop